// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page-loader__vessel{width:100%;height:95vh}", "",{"version":3,"sources":["webpack://./src/_components/molecules/PageLoader/styles.scss"],"names":[],"mappings":"AACI,qBACI,UAAA,CACA,WAAA","sourcesContent":[".page-loader {\n    &__vessel {\n        width: 100%;\n        height: 95vh;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
